import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RidReadingMatrixTimer } from '../../../../mechanics/rid-reading-matrix-timer/rid-reading-matrix-timer';

@Component({
  selector: 'reading-matrix-timer-page',
  imports: [RidReadingMatrixTimer],
  templateUrl: './reading-matrix-timer-page.html',
})
export class ReadingMatrixTimerPage {
  protected readonly $activatedRoute = inject(ActivatedRoute);
  protected readonly $router = inject(Router);

  protected readonly duration = () => parseInt(this.$activatedRoute.snapshot.queryParams['duration'] ?? '30');
  protected readonly previousWordCount = () => parseInt(this.$activatedRoute.snapshot.queryParams['previous-word-count'] ?? '10');
}
